import strftime from 'strftime';

const SECOND = 1000,
   MINUTE = 60 * SECOND,
   HOUR = 60 * MINUTE,
   DAY = 24 * HOUR,
   WEEK = 7 * DAY,
   YEAR = DAY * 365,
   MONTH = YEAR / 12;

onDomReady(function() {
   // Refresh interval in milliseconds.
   var refreshInterval = MINUTE;
   (function update() {
      $$('.js-realtime-date').each(function(el) {
         try {
            el.set('html', relativeDate(new Date(el.title)));
         } catch (e) {
            // Do nothing. Since this is an HTML5 time element older browsers
            // may have trouble with this.
         }
      });
      setTimeout(update, refreshInterval);
   })();

   var absoluteDate = function(dateFormat, time) {
      var locale = App.locale;
      var localizedStrftime = strftime.localizeByIdentifier(locale);
      return localizedStrftime(dateFormat, time || new Date().getTime());
   };

   $$('.js-absolute-date').each(function(el) {
      try {
         el.set('html', absoluteDate(el.get('data-format'), new Date(el.title)));
      } catch (e) {
         // Do nothing. Since this is an HTML5 time element older browsers
         // may have trouble with this.
      }
   });
});

// Todo: Implement plural _js function
function relativeDate(time) {
   var delta = new Date().getTime() - time.getTime();
   var isFutureDate = delta < 0;
   var modifiedDelta;
   var message;

   // The delta is used to find the time bucket and get the unit name so we
   // always want it to be positive.
   delta = Math.abs(delta);

   // Note: this should be the same as the "just now" check
   // in Date::timeSince().
   if (delta < 15 * SECOND) {
      message = _js('just now');
   } else if (delta < MINUTE) {
      modifiedDelta = Math.floor(delta / SECOND);
      message = isFutureDate ? _js('%1 seconds from now') : _js('%1 seconds ago');
   } else if (delta < 2 * MINUTE) {
      message = isFutureDate ? _js('1 minute from now') : _js('1 minute ago');
   } else if (delta < HOUR) {
      modifiedDelta = Math.floor(delta / MINUTE);
      message = isFutureDate ? _js('%1 minutes from now') : _js('%1 minutes ago');
   } else if (Math.floor(delta / HOUR) == 1) {
      message = isFutureDate ? _js('1 hour from now') : _js('1 hour ago');
   } else if (delta < DAY) {
      modifiedDelta = Math.floor(delta / HOUR);
      message = isFutureDate ? _js('%1 hours from now') : _js('%1 hours ago');
   } else if (delta < DAY * 2) {
      if (isFutureDate) {
         message = _js('tomorrow');
      } else {
         message = _js('yesterday');
      }
   } else if (delta < WEEK) {
      // Yes this is supposed to be ceil to be consistent with our backend.
      modifiedDelta = Math.ceil(delta / DAY);
      message = isFutureDate ? _js('%1 days from now') : _js('%1 days ago');
   } else if (delta < 2 * WEEK) {
      message = isFutureDate ? _js('1 week from now') : _js('1 week ago');
   } else if (delta < MONTH) {
      modifiedDelta = Math.floor(delta / WEEK);
      message = isFutureDate ? _js('%1 weeks from now') : _js('%1 weeks ago');
   } else if (delta < 2 * MONTH) {
      message = isFutureDate ? _js('1 month from now') : _js('1 month ago');
   } else if (delta < YEAR) {
      modifiedDelta = Math.floor(delta / MONTH);
      message = isFutureDate ? _js('%1 months from now') : _js('%1 months ago');
   } else if (delta < 2 * YEAR) {
      message = isFutureDate ? _js('1 year from now') : _js('1 year ago');
   } else {
      modifiedDelta = Math.floor(delta / YEAR);
      message = isFutureDate ? _js('%1 years from now') : _js('%1 years ago');
   }

   return message.replace('%1', modifiedDelta);
}

export { relativeDate, MINUTE };
